<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard heading="Programs">
          <DatatablesCRUDActions></DatatablesCRUDActions>
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "TableDatatable",

  data: () => ({
    page: {
      title: "Programs"
    },
    breadcrumbs: [
      {
        text: "Tables",
        disabled: false,
        to: "#"
      },
      {
        text: "Table Datatable",
        disabled: true
      }
    ]
  }),
  components: {
    DatatablesCRUDActions: () => import("./table-data/DatatablesCRUDActions")
  }
};
</script>
